import { Button } from "@mui/material";
import React from "react";
import logger from "services/logger";

const DebugPage : React.FC = () => {
  const uncaught = () => {
    throw new Error("Uncaught Exception Test");
  };

  const caught = () => {
    try {
      throw new Error("Caught Exception Test");
    } catch (error) {
      logger.sendError(error as Error);
    }
  };

  const message = () => {
    logger.sendMessage("Message Test");
  };

  return (
    <div>
      <Button onClick={uncaught}>
        Uncaught Exception
      </Button>
      <Button onClick={caught}>
        Caught Exception
      </Button>
      <Button onClick={message}>
        Send Message
      </Button>
    </div>
  );
};

export default DebugPage;
